import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import Global from '../../APIConfig';
import { ToastContainer, toast } from '../../components/ui/toast';
import SpinnerLoader from '../Loaders/Spinner';
import './Login.css';

/**
 * Otp — OTP confirmation screen, styled to match the login split-screen
 * (wallpaper left, white form panel right). Logic unchanged from the
 * original OTP verification + resend flow.
 */
function Otp() {
  let navigate = useNavigate();
  let [paramValue] = useSearchParams();
  const email = paramValue.get('email');
  const [otp, setOtp] = useState('');
  const [loading, setloading] = useState(false);

  const handleSubmit = () => {
    if (otp == "" || otp == undefined) {
      toast.error("Please Enter OTP");
    }
    else {
      setloading(true);
      axios({
        method: 'post',
        url: Global.baseUrl + 'otpVerification',
        data: {
          email: email,
          otp: otp
        }
      })
        .then(function (response) {
          if (response.data.status == 200) {
            toast.success(response.data.message);
            setTimeout(() => {
              navigate('/');
            }, 1000);
          }
          else {
            setloading(false);
            toast.error(response.data.message);
          }
        })
        .catch(function (error) {
          setloading(false);
          console.log(error);
        });
    }
  };

  const Resendotp = () => {
    axios({
      method: 'post',
      url: Global.baseUrl + 'Resendotp',
      data: {
        email: email
      }
    })
      .then(function (response) {
        if (response.data.status == 200) {
          toast.success(response.data.message);
        }
        else {
          setloading(false);
          toast.warn(response.data.message);
        }
      })
      .catch(function (error) {
        setloading(false);
        console.log(error);
      });
  }

  return (
    <>
      <ToastContainer />
      {loading == true && <SpinnerLoader />}
      <div className="pxl-container">
        {/* Left: wallpaper / branding */}
        <div className="pxl-left">
          <img className="pxl-wallpaper" src="/assets/img/pram-wallpaper.png" alt="" />
          <div className="pxl-left-brand">
            <span className="pxl-left-brand__name">PRAM EXPRESS</span>
            <span className="pxl-left-brand__sub">Courier &amp; Hyperlocal Delivery</span>
          </div>
        </div>

        {/* Right: OTP form panel */}
        <div className="pxl-right">
          <div className="pxl-box">
            <a href="https://pramexpress.com/" target="_blank" rel="noopener noreferrer"><img className="pxl-logo" src="/assets/img/logo.png" alt="Pram Express" /></a>

            <h2 className="pxl-title">Confirm your OTP</h2>
            <p className="pxl-sub">We sent a one-time password to {email || 'your email'}.</p>
            <p className="pxl-sub pxl-sub--muted">Please check the Spam folder if you don't see it in your Inbox.</p>

            <form autoComplete="off" onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
              <div className="pxl-field">
                <label htmlFor="px-otp">One-time password</label>
                <input id="px-otp" type="text" inputMode="numeric" placeholder="Your OTP here" name="otp"
                  autoComplete="one-time-code" value={otp} onChange={(e) => setOtp(e.target.value)} />
              </div>
              <button type="submit" className="pxl-btn">Verify OTP</button>
            </form>

            <p className="pxl-otp-alt">
              Didn't receive the OTP yet? <a href="#" onClick={(e) => { e.preventDefault(); Resendotp(); }}>Resend OTP</a>
            </p>

            <div className="pxl-links">
              <a href="terms-condition" target="_blank" rel="noopener noreferrer">Terms &amp; Condition</a>
              <a href="privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
              <a href="cancellation-policy" target="_blank" rel="noopener noreferrer">Cancellation / Refund Policy</a>
              <a href="contact-us" target="_blank" rel="noopener noreferrer">Support</a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Otp;